import script from "./SimpleToast.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleToast.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleToast.vue?vue&type=style&index=0&id=5e75e2df&lang=scss"

const __exports__ = script;

export default __exports__